<template>
  <div class="item">
    <LoadingWidget v-if="loading" class="py-16" />

    <transition name="fade">
      <v-container v-if="!loading" class="py-8 py-md-12 py-lg-16">
        <TitleWidget
          v-if="item.title"
          :title="item.title"
          :subtitle="item.subtitle"
          class="primary--text justify-center text-center"
        />

        <v-row justify="center">
          <v-col lg="10" class="py-0">
            <img
              v-if="
                item.img &&
                item.img.featured &&
                item.img.featured.path &&
                !video
              "
              :src="files + item.img.featured.path"
              :alt="item.title"
              class="d-block mt-6 mt-md-8 mt-lg-10 item-img"
              width="100%"
            />
            <video
              v-if="video"
              class="item-video d-block mt-6 mt-md-8 mt-lg-10"
              autoplay
              loop
              muted
              controls
              :src="video"
              width="100%"
            ></video>

            <div
              class="
                grey--text
                text-body-1
                mt-6 mt-md-8 mt-lg-10
                item-text
                ck-content
              "
              v-if="item.text"
            >
              <span v-html="item.text"></span>
            </div>
            <GalleryTemplate v-if="images.length >= 1" :images="images" />
          </v-col>
        </v-row>
      </v-container>
    </transition>
  </div>
</template>

<script>
import LoadingWidget from "../widgets/LoadingWidget.vue";
import TitleWidget from "../widgets/TitleWidget.vue";
import GalleryTemplate from "./GalleryTemplate.vue";

export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    images() {
      const items = [];

      if (this.item.img && this.item.img.list)
        this.item.img.list.map(({ path }) => {
          if (this.video) {
            items.push(this.files + path);
          } else {
            this.item.img.featured.path !== path
              ? items.push(this.files + path)
              : null;
          }
        });

      return items;
    },

    video() {
      return this.item.video
        ? this.files + this.item.video.featured.path
        : null;
    },
  },
  components: {
    LoadingWidget,
    TitleWidget,
    GalleryTemplate,
  },
};
</script>

<style lang="scss" scoped>
.item {
  &-img {
    max-height: 60vh;
    object-fit: contain;
    -o-object-fit: contain;

    @media screen and (max-width: 600px) {
      max-height: 80vh;
    }
  }
}
</style>
